import useInput from "hooks/useInput";
import { TextField as IParqueTextField } from "iparque-components";
import React, { InputHTMLAttributes } from "react";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: string;
}

const TextField: React.FC<Props> = ({
  type,
  id,
  name,
  label,
  autoComplete,
  ...props
}) => {
  const { field, meta, hasError } = useInput(name);

  return (
    <IParqueTextField
      type={type}
      id={id}
      label={label}
      error={hasError}
      helperText={hasError ? meta.error : ""}
      autoComplete={autoComplete || undefined}
      {...field}
      {...props}
    />
  );
};

export default TextField;
